import { get, patch } from "../../api/api";
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

export const obtemVariaveisGlobais = async (): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>('/variaveis-globais');
};

export const atualizarVariaveisGlobais = async (payload: { variaveis: { variavelId: string; valor: string }[] }): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>('/variaveis-globais', payload);
};
